import { render, staticRenderFns } from "./WcButton.vue?vue&type=template&id=63c1eb41&scoped=true"
import script from "./WcButton.vue?vue&type=script&lang=js"
export * from "./WcButton.vue?vue&type=script&lang=js"
import style0 from "./WcButton.vue?vue&type=style&index=0&id=63c1eb41&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c1eb41",
  null
  
)

export default component.exports